import React from 'react'
import { TabBar, TabButton } from './MobileTabs.styles'

export type BalancesTab = 'members' | 'activity'

interface Props {
	value: BalancesTab
	onChange: (tab: BalancesTab) => void
}

const MobileTabs: React.FC<Props> = ({ value, onChange }) => (
	<TabBar role="tablist">
		<TabButton
			type="button"
			role="tab"
			aria-selected={value === 'members'}
			$active={value === 'members'}
			onClick={() => onChange('members')}
		>
			Balances
		</TabButton>
		<TabButton
			type="button"
			role="tab"
			aria-selected={value === 'activity'}
			$active={value === 'activity'}
			onClick={() => onChange('activity')}
		>
			Activity
		</TabButton>
	</TabBar>
)

export default MobileTabs
